import {Box, Typography} from '@mui/material';
import {FC, useContext, useEffect, useState} from 'react';
import Radio from '@/shared/components/Radio';
import {uploadedContactListTableStyle} from './UploadedContactListTable.style';
import * as XLSX from 'xlsx';
import {UploadContactListContext} from '../../../UploadContactListContext';
import Button from '@/shared/components/Button';

const UploadedContactListTable: FC = () => {
	const [sheetData, setSheetData] = useState<any[][]>([]);

	const {handleNextStep, selectedFile, sheetName, headerIndex, setHeaderIndex} = useContext(UploadContactListContext);

	useEffect(() => {
		if (selectedFile && sheetName) {
			const readFile = async () => {
				const data = await selectedFile.arrayBuffer();
				const workbook = XLSX.read(data, {type: 'array'});
				const worksheet = workbook.Sheets[sheetName];
				const json = XLSX.utils.sheet_to_json(worksheet, {header: 1});
				setSheetData(json as any[][]);
			};
			readFile();
		}
	}, [selectedFile, sheetName]);

	return (
		<Box>
			<Box sx={uploadedContactListTableStyle.table}>
				<Typography sx={uploadedContactListTableStyle.title}>Select your first row:</Typography>
				<Box sx={uploadedContactListTableStyle.container}>
					{sheetData.map((row, index) => {
						// Визначаємо максимальну кількість колонок (наприклад, 9, як у ваших widths)
						const maxColumns = 9;

						// Створюємо "повний" рядок: беремо існуючі дані і заповнюємо порожнечі
						const normalizedRow = Array.from({length: maxColumns}, (_, i) => row[i] ?? '');

						return (
							<Box key={index} sx={uploadedContactListTableStyle.tableRow}>
								<Radio
									value={index.toString()}
									checked={headerIndex === index}
									onChange={() => setHeaderIndex(index)}
								/>

								{normalizedRow.map((cell, cellIndex) => {
									const widths = ['10%', '10%', '10%', '15%', '10%', '15%', '10%', '10%', '5%'];
									return (
										<Box
											key={cellIndex}
											sx={{
												...uploadedContactListTableStyle.cell,
												width: widths[cellIndex],
												flexShrink: 0,
											}}
										>
											{cell && String(cell).trim() !== '' ? cell : '\u00A0'}
										</Box>
									);
								})}
							</Box>
						);
					})}
				</Box>
			</Box>

			<Box sx={uploadedContactListTableStyle.buttonWrapper}>
				<Button title="Next Step" disabled={headerIndex === null} onClick={handleNextStep} />
			</Box>
		</Box>
	);
};

export default UploadedContactListTable;
